import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import ReactIntersectionObserver from '../react-intersection-observer/ReactIntersectionObserver';

/**
 * Postpones children rendering until its placeholder becomes visible
 */
export class LazyLoadComponent extends Component {
    static propTypes = {
        /** The element whose exposure we want to track. See ReactIntersectionObserver children for details. */
        placeholder: ReactIntersectionObserver.propTypes.children,
        /** Amount of pixels added to the placeholder dimensions when considering its visibility */
        offset: PropTypes.number
    };

    static defaultProps = {
        children: null,
        offset: 0
    }

    constructor(props) {
        super(props);
        this.state = {hasBeenSeen: false};
    }

    onIntersection = ({isIntersecting}) => {
        if (isIntersecting) {
            this.setState({hasBeenSeen: true});
        }
    }

    render() {
        const {placeholder, children, offset, isMobile} = this.props;

        return this.state.hasBeenSeen ?
            children :
            <ReactIntersectionObserver
                rootMargin={`${offset}px`}
                onIntersection={this.onIntersection}
                threshold={isMobile ? 0.1 : 0}
            >
                {placeholder}
            </ReactIntersectionObserver>;
    }
}

export const mapStateToProps = ({config: {isMobile}}) => ({isMobile});

const LazyLoad = connect(mapStateToProps)(LazyLoadComponent);

LazyLoad.displayName = 'LazyLoad';

export default LazyLoad;
